<script lang="ts" context="module">
  import {
    AnimationPlayerEvents,
    AnimationTimelinePlayer
  } from '../../services/animation/timeline-player/animation-timeline-player';
  import {writable} from 'svelte/store';
  import {getInstance} from '../../services/animation';
  const attachedEvents = [];
  let shouldRecord = false;
  export const animationPlayerInstance = new AnimationTimelinePlayer();
  export const animationPlayerStore = writable({
    loading: false,
    buffering: false,
    canPlay: false,
    playing: false
  });

  export function enableAnimationRecording() {
    shouldRecord = true;
    animationPlayerInstance.shouldRecord = true;
  }

  export function setAnimationControllerLoading(val: boolean) {
    animationPlayerStore.update(store => ({
      ...store,
      loading: val,
      canPlay: val ? false : true
    }));
  }

  export function seekAnimationController(time: number) {
    animationPlayerInstance.seek(time);
  }

  export function attachProductionTimelinePlaythrough() {
    animationPlayerInstance.on(AnimationPlayerEvents.PLAYING, () => {
      if (window.electronAPI && shouldRecord) {
        try {
          window.electronAPI.startRecording();
        } catch (err) {
          console.warn('[RENDERER ERR] ', err);
        }
      } else {
        console.warn('[RENDERER] UNABLE TO FIND ELECTRON API');
      }
    });
  }

  export function attachVideoToTimelinePlayer(video: HTMLVideoElement) {
    // console.log("Attaching video to timeline player.", video);
    setupEvents();

    animationPlayerInstance.attachVideoNode(video);

    function setupEvents() {
      animationPlayerInstance.clearEvents();
      animationPlayerInstance.on(AnimationPlayerEvents.PLAYING, () => {
        const animationService = getInstance();
        animationService.playAudio();
        // animationService.pauseBGVideoElements();
      });

      animationPlayerInstance.on(AnimationPlayerEvents.PAUSE_REQUESTED, () => {
        const animationService = getInstance();
        animationService.pauseAudio();
        animationService.pauseBGVideoElements();
      });

      animationPlayerInstance.on(AnimationPlayerEvents.PLAY_REQUESTED, () => {
        const animationService = getInstance();
        animationService.seekAudio();
      });

      animationPlayerInstance.on(AnimationPlayerEvents.ENDED, () => {
        const animationService = getInstance();
        animationService.pauseBGVideoElements();
        animationService.seekAudio(0);
      });

      animationPlayerInstance.on(AnimationPlayerEvents.PLAY_READY, () => {
        animationPlayerStore.update(store => ({
          ...store,
          loading: false,
          canPlay: true
        }));
      });

      animationPlayerInstance.on(AnimationPlayerEvents.BUFFERING, () => {
        animationPlayerStore.update(store => ({
          ...store,
          buffering: true,
          loading: true,
          canPlay: false
        }));
      });

      animationPlayerInstance.on(AnimationPlayerEvents.STOP_REQUEESTED, () => {
        const animationService = getInstance();
        try {
          animationService.pause();
          animationService.restartTimeline();
          animationService.seekVideo();
        } catch (err) {
          console.warn('Problem with stopping');
        }
      });

      animationPlayerInstance.on(AnimationPlayerEvents.SEEKED, time => {
        const animationService = getInstance();
        try {
          animationService.seekBGVideoElements(time);
        } catch (err) {
          console.warn('Could not seek bg video elements');
        }
      });
    }
  }
</script>

<script lang="ts">
  $: bufferingText = $animationPlayerStore.buffering ? 'Buffering' : 'Rendering';
</script>

{#if $animationPlayerStore.loading && bufferingText == 'Buffering'}
  <div class="animationController">
    <div class="absolute left-0 top-0 z-10 h-full w-full bg-gray-300 opacity-50"></div>
    <span class="z-20 block shadow-lg">{bufferingText}...</span>
  </div>
{/if}

<style lang="postcss" scoped>
  .animationController {
    @apply absolute left-0 top-0 flex h-full w-full items-center justify-center text-lg font-bold;
    z-index: 1000;
  }
</style>
